export default "/images/vendor/@coreui/icons/svg/flag/cif-ee.svg?c87b956db1be7d3ec25acd3e9c11b959";